import { Component } from "vue-property-decorator"

import FAlertBase from "./fAlert.client.base"

@Component
export default class FAlertWeb extends FAlertBase {}
